<div class="status-change-container">
  <h2 class="title">Change status</h2>

  <div class="notes-section" *ngIf="notes && notes.length">
    <h3 class="notes-title">Status history</h3>
    <mat-divider></mat-divider>
    <div class="notes-list" [class.scrollable]="notes.length > 3">
      <div class="notes-list-inner">
        @for (n of notes; track n.id) {
          <div class="note-item">
            <div class="note-top">
              <div class="status-transition-pill">
                <app-status-pill [status]="n.changeFrom" [label]="getStatusLabel(n.changeFrom)"></app-status-pill>
                <mat-icon class="arrow">arrow_forward</mat-icon>
                <app-status-pill [status]="n.changeTo" [label]="getStatusLabel(n.changeTo)"></app-status-pill>
              </div>
              <span class="spacer"></span>
              <span class="note-meta">{{ n.changeDate | date: 'medium' }}</span>
            </div>
            <div class="note-bottom">
              <div class="initials-wrapper">
                <div class="initials" [matTooltip]="n.changedBy?.name || ''">
                  {{ n.changedBy?.name ? (n.changedBy?.name | slice: 0 : 1) : 'U' }}
                </div>
              </div>

              <div class="note-text" [matTooltip]="n.changeNote">
                {{ n.changeNote || 'No note provided' | slice: 0 : 120 }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <form [formGroup]="form" class="status-change-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>New status</mat-label>
      <mat-select class="status-select" formControlName="changeTo">
        <mat-option *ngFor="let s of statuses" [value]="s">{{ s }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Note (optional)</mat-label>
      <textarea matInput formControlName="changeNote" rows="4" maxlength="500"></textarea>
      <mat-hint align="end">{{ form.get('changeNote')?.value?.length || 0 }} / 500</mat-hint>
    </mat-form-field>

    <div class="actions">
      <button mat-raised-button type="button" class="aker-context-button cancel-btn" (click)="cancel()">Cancel</button>
      <button mat-raised-button type="button" class="aker-context-button save-btn" (click)="confirm()" [disabled]="form.invalid">
        Confirm
      </button>
    </div>
  </form>
</div>
